import { render, staticRenderFns } from "./AudienceStep.vue?vue&type=template&id=36f679a0&scoped=true"
import script from "./AudienceStep.vue?vue&type=script&lang=js"
export * from "./AudienceStep.vue?vue&type=script&lang=js"
import style0 from "./AudienceStep.vue?vue&type=style&index=0&id=36f679a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f679a0",
  null
  
)

export default component.exports